import React, { useState, useCallback, memo } from "react"
import { emailFormatCheck } from "@/utils"
import excelTemplate from "@/assets/files/sparca_excel_sheet_template.xlsx"
import SheetJSAppHook from "@/hooks/SheetJSAppHook"
import { makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import clsx from "clsx"
import StickyHeadTable from "@/components/common/StickyHeadTable"
import Link from "@material-ui/core/Link"

const useStyles = makeStyles((theme) => ({
    dataInputWrapper: {
        padding: "7px",
        margin: "5px 0",
        border: "1px solid #a5a5a5",
        color: "#000",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: "5px",
    },
    statusWrapper: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "normal",
    },
    smallFont: {
        fontSize: "80%",
    },
    greyColor: {
        color: theme.palette.sparcaDarkGrey.main,
    },
    downloadLink: {
        color: theme.palette.primary.main,
    },
    showErrorList: {
        color: theme.palette.primary.main,
        textDecoration: "underline",
        cursor: "pointer",
    },
    downloadLinkText: {
        display: "inline-block",
    },
}))

const HandleExcelSheet = memo((props) => {
    const classes = useStyles()
    const { handleSetParticipantListAddParticipant } = props
    const [successAddCount, setSuccessAddCount] = useState(0)
    const [failedAddCount, setFailedAddCount] = useState(0)
    const [successMultiUploadStatus, setSuccessMultiUploadStatus] = useState({
        status: 0,
        text: "",
    })

    const handleSuccessMultiUploadStatus = useCallback((status) => {
        setSuccessMultiUploadStatus(status)
    }, [])

    // for the list
    const [columns] = useState(() => [
        { id: "firstName", label: "First name", minWidth: 170 },
        { id: "lastName", label: "Last name", minWidth: 170 },
        { id: "email", label: "Email", minWidth: 170 },
    ])
    const [errorList, setErrorList] = useState([])
    const [showErrorList, setShowErrorList] = useState(false)

    const handleData = useCallback(
        (dataSheet) => {
            const newParticipantTemp = []
            const errorListTemp = []
            let successCount = 0
            let failedCount = 0
            if (dataSheet.data.length >= 1) {
                setSuccessMultiUploadStatus({
                    status: 1,
                    text: "Checking",
                    class: "pending-notification",
                })
                for (let n = 1; n <= dataSheet.data.length - 1; n++) {
                    const firstName = dataSheet.data[n][0]
                    const lastName = dataSheet.data[n][1]
                    const email = dataSheet.data[n][2]
                    if (emailFormatCheck(email)) {
                        const participantNew = {
                            firstName,
                            lastName,
                            email,
                        }
                        newParticipantTemp.push(participantNew)
                        successCount++
                    } else {
                        failedCount++
                        errorListTemp.push({
                            firstName,
                            lastName,
                            email,
                        })
                    }
                }
                setSuccessAddCount(successCount)
                setFailedAddCount(failedCount)
                if (handleSetParticipantListAddParticipant) {
                    handleSetParticipantListAddParticipant(newParticipantTemp)
                }
                setErrorList(errorListTemp)
                setSuccessMultiUploadStatus({
                    status: 2,
                    text: "Finished",
                    class: "success-notification ",
                })
            }
        },
        [successAddCount, failedAddCount]
    )

    return (
        <Box className="participant-upload-list-wrapper">
            <Box className="upload-list-wrapper">
                <SheetJSAppHook handleData={handleData} handleSuccessMultiUploadStatus={handleSuccessMultiUploadStatus} />
                <Box className={clsx(classes.statusWrapper, "status-wrapper")}>
                    <Box className="upload-status-wrapper">
                        <Box className={`${successMultiUploadStatus.class} upload-status`}>
                            <Typography className={classes.smallFont}>{successMultiUploadStatus.text}</Typography>
                        </Box>
                        <Box>
                            {errorList.length ? (
                                <Typography
                                    className={clsx(classes.smallFont, classes.showErrorList)}
                                    onClick={() => setShowErrorList((prev) => !prev)}
                                >
                                    {!showErrorList ? "Show" : "Hide"} Error List
                                </Typography>
                            ) : null}
                        </Box>
                    </Box>
                    <Box>
                        <Box>
                            <Typography className={clsx(classes.smallFont, classes.greyColor, classes.downloadLinkText)}>
                                <Link
                                    className={clsx(classes.downloadLink, "participant-template-download-link")}
                                    href={excelTemplate}
                                    download="template.xlsx"
                                >
                                    Download Template
                                </Link>
                                &nbsp;for easy bulk upload
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {errorList.length && showErrorList ? (
                    <Box className="error-list" mt={3}>
                        <Typography className={classes.smallFont}>
                            Wrong Email Format List:
                            <Box mt={1}>
                                <StickyHeadTable columns={columns} rows={errorList} />
                            </Box>
                        </Typography>
                    </Box>
                ) : null}
            </Box>
        </Box>
    )
})

export default HandleExcelSheet
